import { sendTrackingEvent } from 'components/analytics/conversions/tracking';
import { LOGIN_TRIGGERED } from 'components/analytics/conversions/constants/actions';
import FormController from '../../../controllers/form-controller';

export default class ResetPasswordFormController extends FormController {
  static values = {
    type: String,
  }

  connect() {
    super.connect();

    this.trackTriggerEvent();
  }

  validateFields(event) {
    event.preventDefault();

    super.validateFields();

    if (this.formValid) {
      this.submit();
    }
  }

  trackTriggerEvent() {
    const category = this.typeValue === 'reset' ? 'Form-Password_Reset' : 'Form-Password_Update';
    const payload = {
      data: {
        category,
        action: LOGIN_TRIGGERED,
      },
    };

    sendTrackingEvent(payload);
  }
}
